const userActionTypes = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  SIGNIN_START: "SIGNIN_START",
  SIGNIN_SUCCESS: "SIGNIN_SUCCESS",
  SIGNIN_FAILURE: "SIGNIN_FAILURE",
  SIGNOUT_START: "SIGNOUT_START",
  SIGNOUT_SUCCESS: "SIGNOUT_SUCCESS",
  SIGNOUT_FAILURE: "SIGNOUT_FAILURE",
  STOP_LOADING: "STOP_LOADING",
  START_LOADING: "START_LOADING",
  SET_IS_VERIFIED: "SET_IS_VERIFIED",
  SET_MFA_STATUS: "SET_MFA_STATUS",
  REMOVE_MFA_STATUS: "REMOVE_MFA_STATUS",
  SET_QR_CODE_DATA: "ADD_QR_CODE_DATA",
  SET_USER_LOADER: "SET_USER_LOADER",
  SET_QR_CODE_LOADER: "SET_QR_CODE_LOADER",
  SET_ACCESS_TOKEN: "SET_ACCESS_TOKEN",
  SET_USER_NAME: "SET_USER_NAME",
  SET_USER_EMAIL: "SET_USER_EMAIL",
  SET_USER_PERMISSION: "SET_USER_PERMISSION",
  SET_CORP_DETAILS: "SET_CORP_DETAILS",
  RESET_REDUX: "RESET_REDUX",
};

export default userActionTypes;
